import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { CartContext } from '../../context/CartContext.esm.js';
import { CartSettingsContext } from '../../context/CartSettingsContext.esm.js';
import 'lodash/isEqual';
import 'markdown-to-jsx';
import '@invitae/ids-react';
import 'lodash/isEmpty';
import '@invitae/analytics-queue';
import 'lodash/flatten';
import 'lodash/flowRight';
import '../../constants/analytics.esm.js';
import '../../modals/content/index.esm.js';
import '../../modals/content/default_validation_error.esm.js';
import '../../modals/ModalBuilder.models.esm.js';
import 'squirrelly';
import '../../modals/postProcessingActions/processLocationValidationError.esm.js';
import '@invitae/stargate-ts-fetch';
import 'classnames';
import '../../constants/api.esm.js';
import { Loading } from '../Loading/Loading.esm.js';
import OrderCard from '../OrderCard/OrderCard.esm.js';
import { PatientInfoBanner } from '../PatientInfoBanner/PatientInfoBanner.esm.js';
import CartSummary from './CartSummary.esm.js';
import styles from './Cart.module.esm.js';

/**
 * This component is responsible for rendering a cart.
 */
var Cart = function (_a) {
    var _b;
    var clearOrderFromSession = _a.clearOrderFromSession, isCancerPayorIssuesEnabled = _a.isCancerPayorIssuesEnabled, _c = _a.isCompact, isCompact = _c === void 0 ? false : _c, _d = _a.isEditable, isEditable = _d === void 0 ? true : _d, _e = _a.userCountry, userCountry = _e === void 0 ? 'US' : _e, rest = __rest(_a, ["clearOrderFromSession", "isCancerPayorIssuesEnabled", "isCompact", "isEditable", "userCountry"]);
    var _f = React.useContext(CartContext), cart = _f.cart, meta = _f.meta, isUserAuthenticated = _f.isUserAuthenticated, showPatientInfoBanner = _f.showPatientInfoBanner;
    var patientInformation = (_b = meta === null || meta === void 0 ? void 0 : meta.patientInformation) !== null && _b !== void 0 ? _b : {};
    if ((cart && !cart.orderGroups.length) || !isUserAuthenticated)
        return (React.createElement("h6", { className: styles.cartIsEmptyMessage, "data-testid": "empty-cart" },
            showPatientInfoBanner && React.createElement(PatientInfoBanner, { patientInformation: patientInformation }),
            "Your cart is empty"));
    if (!cart)
        return React.createElement(Loading, null);
    var rereq = meta === null || meta === void 0 ? void 0 : meta.rereq;
    var parent = rereq === null || rereq === void 0 ? void 0 : rereq.parent;
    var orderGroupsCount = cart.orderGroups.length;
    return (React.createElement(CartSettingsContext.Provider, { value: __assign({ isCompact: isCompact, isEditable: isEditable }, rest) },
        (rereq === null || rereq === void 0 ? void 0 : rereq.isRerequisition) && (React.createElement("p", { className: styles.rereqInformation, "data-testid": "rereq-header" },
            "This is for your patient: ", parent === null || parent === void 0 ? void 0 :
            parent.patientName,
            ". This order is a ",
            React.createElement("strong", null, "re-requisition"),
            " for",
            ' ', parent === null || parent === void 0 ? void 0 :
            parent.reqId,
            ".")),
        React.createElement(CartSummary, { isCompact: isCompact }),
        showPatientInfoBanner && React.createElement(PatientInfoBanner, { patientInformation: patientInformation }),
        React.createElement("div", { className: styles.root },
            React.createElement("section", { className: styles.orderHeader }, cart.orderGroups.map(function (orderGroup, orderGroupIndex) { return (React.createElement(OrderCard, { clearOrderFromSession: clearOrderFromSession, isCancerPayorIssuesEnabled: isCancerPayorIssuesEnabled, isRerequisition: rereq === null || rereq === void 0 ? void 0 : rereq.isRerequisition, key: orderGroup.rereqSetCode, orderGroup: orderGroup, orderGroupIndex: orderGroupIndex, orderGroupsCount: orderGroupsCount, userCountry: userCountry })); })))));
};

export { Cart };
//# sourceMappingURL=Cart.esm.js.map
